import gsap, { SplitText } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";
import cmsMerge from "@/lib/cms-merge";
import { ref, watch } from "@vue/reactivity";

export default function (element, _dataset) {
  // merge CMS data
  const logos = Array.from(element.querySelectorAll('[data-element="logo"]'));
  const destinations = Array.from(
    element.querySelectorAll('[data-element="logo-destination"]'),
  );
  const tabMenus = cmsMerge(element, logos, destinations);

  // Select tabs elements
  const buttons = getTabLinks('[data-element="button"]');
  const index = ref("");

  watch(index, handleTabChange);

  tabMenus.forEach((e) => {
    gsap.set(e, {
      opacity: 0,
      filter: "blur(10px)",
      scale: 0.95,
    });
  });

  index.value = buttons.entries().next().value[0];
  console.log(index.value);

  function getTabLinks(query) {
    const map = new Map();
    Array.from(element.querySelectorAll(query)).map((e) => {
      map.set(e.getAttribute("data-category"), e);

      e.addEventListener("click", () => {
        index.value = e.getAttribute("data-category");
      });
    });
    return map;
  }

  function handleTabChange(newVal, oldVal) {
    console.log(buttons);
    const newButton = buttons.get(newVal);
    const newTabMenu = tabMenus.get(newVal);

    const oldButton = buttons.get(oldVal);
    const oldTabMenu = tabMenus.get(oldVal);

    console.log(newButton, newTabMenu, oldButton, oldTabMenu);

    let tl = gsap.timeline({});

    tl.to(newButton, {
      backgroundColor: "#F1DAFE",
    });
    tl.to(
      oldButton,
      {
        backgroundColor: "transparent",
      },
      "<",
    );
    tl.to(
      newTabMenu,
      {
        opacity: 1,
        filter: "blur(0px)",
        scale: 1,
      },
      "<",
    );
    tl.to(
      oldTabMenu,
      {
        opacity: 0,
        filter: "blur(10px)",
        scale: 0.98,
      },
      "<",
    );
  }
}
